<app-dashboard-layout [loading]="loading" [downloader]="downloader" [dialog]="dialog">
  <app-notification-alert [data]="notification"></app-notification-alert>

  <section
    class="grid gap-4 grid-cols-1 sm:grid-cols-2 md:gap-6 lg:grid-cols-3 xl:grid-cols-4"
  >
    <app-dashboard-card
      *ngIf="_checks.DisableFeesGeneration === false"
      routerLink="/payments/generate"
      title="Generate Fees"
      icon="/assets/icons/papers.svg"
      caption="Generate Fees."
    ></app-dashboard-card>

    <app-dashboard-card
      (click)="openPopup('payAdvice')"
      title="View Pay Advice"
      icon="/assets/icons/receipt.png"
      caption="Generate Payment Advice."
    ></app-dashboard-card>
    
    <app-dashboard-card
      *ngFor="let link of links"
      [routerLink]="link.slug"
      [title]="link.title"
      [icon]="link.icon"
      [caption]="link.text"
    ></app-dashboard-card>

    <app-dashboard-card
      (click)="openPopup('printReceipt')"
      title="Print Receipt"
      icon="/assets/icons/printer.svg"
      caption="Print your payment history."
    ></app-dashboard-card>

    <app-dashboard-card
      routerLink="/payments/fund-wallet"
      title="Fund Wallet"
      icon="/assets/icons/credit-card.png"
      caption="Add funds to your wallet for future payments."
    ></app-dashboard-card>

    <app-dashboard-card
      (click)="refreshPayment()"
      title="Refresh Payment Status"
      icon="/assets/icons/refresh.png"
      caption="Refresh your payment status to reflect any recent changes."
    ></app-dashboard-card>
  </section>

 <!-- Popup Modal -->
<div
*ngIf="dialogVisible"
role="dialog"
aria-modal="true"
aria-labelledby="modal-title"
class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-500 bg-opacity-75"
>
<div class="bg-white rounded-lg shadow-xl transform transition-all w-full max-w-screen-md overflow-hidden">
  <form class="flex flex-col mx-auto max-w-screen-md p-4 z-20 justify-center space-y-6" (ngSubmit)="submitPopup()">
    <!-- Session Dropdown -->
    <h1 class="font-medium text-center text-lg">
      Select Term and Session
    </h1>
    <div>
      <div class="bg-white border border-primary rounded-lg w-full p-2">
        <select
          id="session"
          [(ngModel)]="selectedSession"
          name="session"
          class="w-full mt-1 px-2 py-1 rounded focus:outline-none"
        >
          <option disabled value="">Select a Session</option>
          <option *ngFor="let session of sessions" [value]="session">
            {{ session }}
          </option>
        </select>
      </div>
    </div>
  
    <!-- Term Dropdown -->
    <div>
      <div class="bg-white border border-primary rounded-lg w-full p-2">
        <select
          id="term"
          [(ngModel)]="selectedTerm"
          name="term"
          class="w-full mt-1 px-2 py-1 rounded focus:outline-none"
        >
          <option disabled value="">Select a Term</option>
          <option *ngFor="let termOption of terms" [value]="termOption.Id">
            {{ termOption.Label }}
          </option>
        </select>
      </div>
    </div>
    <!-- Buttons -->
    <div class="flex space-x-2">
      <app-button-primary
      (click)="closeDialog()"class="w-1/2 py-2" [outline]="true"  type="button">
        Cancel
      </app-button-primary>
      <app-button-primary [disabled]="loading" type="submit" class="w-1/2 py-2">
        Submit
      </app-button-primary>
    </div>
  </form>
</div>
</div>


</app-dashboard-layout>
